import {useRef} from 'react'

import {useJobId} from '../../EditPipelinePage/EditPipelinePage.hooks'
import {usePipelineId} from '../../hooks/pipeline'

import type {SettingsValueStore, SettingsStoreValue} from './StoredSettingsValueContext.types'

function useStoredSettingsValueProvider() {
  const jobId = useJobId()
  const pipelineId = usePipelineId()
  const rootKey = jobId ?? pipelineId
  const store = useRef<SettingsValueStore>({})
  const setValueToStoredSettings = (key: string, value: SettingsStoreValue) => {
    store.current[`${rootKey}_${key}`] = value
  }
  const getValueFromStoredSettings = (key: string) => store.current[`${rootKey}_${key}`]

  return {
    setValueToStoredSettings,
    getValueFromStoredSettings,
  }
}

export default useStoredSettingsValueProvider
